<template>
	<div
		:class="showBlurryBackground ? 'blurbackground' : ''"
		style="width: 100%; position: absolute; bottom: 0px; z-index: 1000"
	>
		<div
			style="
				width: 100%;
				height: fit-content;
				padding: 10px;
				gap: 20px;
				justify-content: space-between;
				align-items: flex-end;
				display: inline-flex;
			"
		>
			<div
				style="
					height: 60px;
					flex-grow: 1;
					background: #4db6ac;
					border-radius: 20px;
					overflow: hidden;
					display: flex;
				"
			>
				<div
					style="
						width: 100%;
						height: 100%;
						padding: 10px;
						justify-content: center;
						align-items: center;
						display: flex;
					"
					:style="model == 'dataentry' ? 'background: white' : ''"
					@click="model = 'dataentry'"
				>
					<v-icon icon="mdi-cards-variant" size="32px" :color="model == 'dataentry' ? '#4DB6AC' : 'white'" />
					<!-- ballot-outline card-text-outline cards-variant dns-outline -->
				</div>
				<div
					style="
						width: 100%;
						height: 100%;
						padding: 10px;
						justify-content: center;
						align-items: center;
						display: flex;
					"
					:style="model == 'chat' ? 'background: white' : ''"
					@click="model = 'chat'"
				>
					<v-icon icon="mdi-forum-outline" size="32px" :color="model == 'chat' ? '#4DB6AC' : 'white'" />
				</div>
				<div
					style="
						width: 100%;
						height: 100%;
						padding: 10px;
						justify-content: center;
						align-items: center;
						display: flex;
					"
					:style="model == 'graph' ? 'background: white' : ''"
					@click="model = 'graph'"
				>
					<v-icon icon="mdi-graph-outline" size="32px" :color="model == 'graph' ? '#4DB6AC' : 'white'" />
				</div>
			</div>
			<div
				style="
					width: 80px;
					height: 80px;
					border-radius: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
					background: #4db6ac;
				"
				:class="{ 'nta-recording': audioStore.isRecording }"
				:variant="audioStore.isRecording ? 'tonal' : 'text'"
				@click="toggleAudio(session.sessionId)"
				@mousedown="holdAudio(session.sessionId)"
				@touchstart="holdAudio(session.sessionId)"
			>
				<v-icon size="57px" color="white">{{
					audioStore.isRecording ? "mdi-microphone" : "mdi-microphone-off"
				}}</v-icon>
				<!-- <v-icon v-if="true" icon="mdi-microphone" size="57px" color="white" />
        <v-icon v-else icon="mdi-microphone-off" size="57px" color="white" /> -->
			</div>
		</div>
	</div>
	<!-- <nta-echo-chamber
		v-if="showEchoChamber"
		:alternisHost="alternisHost"
		width="560px"
		height="600px"
		teleport="body"
		@close="showEchoChamber = false"
		@microphone-validated="onMicrophoneValidated"
	/> -->
</template>

<script setup lang="ts">
import type { Session } from "@lr-notitia/notitia-alternis/schemas";
import { ref, computed } from "vue";
import { LanguageCode } from "@lr-notitia/notitia-operator/schemas";
import { useDomainStore } from "../../../store/domain";
import { useSessionStore } from "../../../store/alternis/session";
import { useAudioStore } from "../../../store/alternis/audio";
import { useConfigStore } from "../../../store/alternis/config";

const model = defineModel<"dataentry" | "chat" | "graph">();

defineProps({
	showBlurryBackground: {
		type: Boolean,
		default: true,
	},
});

const domainStore = useDomainStore();
const sessionStore = useSessionStore();
const audioStore = useAudioStore();
const configStore = useConfigStore();
const pressToRecordThrottleTimestamp = ref(Date.now());

const alternisHost = computed(() => {
	let host = window.location.host;
	if (host.endsWith(".dev")) return "https://alternis.notitia.world";
	if (host.endsWith(".world")) return "https://alternis.notitia.world";
	return "https://alternis.notitia.world";
});
// const showEchoChamber = ref(false);

const session = computed<Session>(
	() =>
		sessionStore.session || {
			sessionId: "",
			users: [],
			messages: [],
			bots: [],
		}
);

function toggleAudio(sessionId: string) {
	if (configStore.holdToRecord) return;
	if (localStorage.getItem("selectedMicrophoneDeviceId") !== null) {
		audioStore.toggleRecording(
			sessionId,
			domainStore.account?.id || "",
			domainStore.account?.firstname + " " + domainStore.account?.lastname
		);
	}
	// else {
	// 	showEchoChamber.value = true;
	// }
}

const DEBOUNCE_TIME = 700; // ms
function holdAudio(sessionId: string) {
	if (!configStore.holdToRecord) return;
	if (localStorage.getItem("selectedMicrophoneDeviceId") !== null) {
		if (timeSinceLastBtnPress() > DEBOUNCE_TIME) {
			pressToRecordThrottleTimestamp.value = Date.now();
			toggleRecording(sessionId);
			addEventListener(
				"mouseup",
				() => {
					const timeSincePress = timeSinceLastBtnPress();
					if (timeSincePress > DEBOUNCE_TIME) {
						toggleRecording(sessionId);
					} else {
						setTimeout(() => {
							toggleRecording(sessionId);
						}, DEBOUNCE_TIME - timeSincePress);
					}
				},
				{ once: true }
			);
			addEventListener(
				"touchend",
				() => {
					const timeSincePress = timeSinceLastBtnPress();
					if (timeSincePress > DEBOUNCE_TIME) {
						toggleRecording(sessionId);
					} else {
						setTimeout(() => {
							toggleRecording(sessionId);
						}, DEBOUNCE_TIME - timeSincePress);
					}
				},
				{ once: true }
			);
		}
	}
	// else {
	// 	showEchoChamber.value = true;
	// }
}

function toggleRecording(sessionId: string) {
	audioStore.toggleRecording(
		sessionId,
		domainStore.account?.id || "",
		domainStore.account?.firstname + " " + domainStore.account?.lastname
	);
}

function timeSinceLastBtnPress(): number {
	return Date.now() - pressToRecordThrottleTimestamp.value;
}

// function onMicrophoneValidated(data: {
// 	device: { deviceId: string; groupId: string; kind: string; label: string };
// 	lang: LanguageCode;
// 	type: "microphone-validated";
// }) {
// 	audioStore.selectedMicrophoneDeviceId = data.device.deviceId;
// 	showEchoChamber.value = false;
// 	localStorage.setItem("selectedMicrophoneDeviceId", data.device.deviceId);
// }
</script>

<style lang="scss" scoped>
.blurbackground {
	&:after {
		content: "";
		position: absolute;
		height: 175px;
		width: 100%;
		bottom: 0;
		left: 0;
		backdrop-filter: blur(10px);
		mask: linear-gradient(transparent, white 60%);
		z-index: -1;
		pointer-events: none;
	}
}

.nta-recording {
	animation: nta-recording 1s infinite;
}
@keyframes nta-recording {
	0%,
	100% {
		color: rgb(var(--v-theme-error));
	}
	70% {
		color: rgba(var(--v-theme-error), 0.5);
	}
}
</style>
